import { Injectable } from "@angular/core";
import { Vistoria } from '@tivic-team/manager-ts/dist/mob/entities/vistoria/vistoria.entity';
import { VistoriaController } from '../../controllers/mob/vistoria.controller';
import { VistoriaDTO, VistoriaListDTO } from '../../model/dtos/mob/vistoria.dto';
import { LoaderService } from "../loader.service";
import { VistoriaSearch } from './vistoria.search';

@Injectable()
export class VistoriaService {

    constructor(
        private _vistoriaController: VistoriaController,
        private _loaderService: LoaderService
    ) { }

    async salvar(vistoria: VistoriaDTO): Promise<VistoriaDTO> {
        this._loaderService.show();
        if (vistoria.cdVistoria && vistoria.cdVistoria > 0) {
            return this._vistoriaController.atualizar(vistoria).finally(() => this._loaderService.hide());
        } else {
            return this._vistoriaController.salvar(vistoria).finally(() => this._loaderService.hide());
        }
    }

    async salvarLote(array): Promise<Array<VistoriaDTO>> {
        this._loaderService.show();
        return this._vistoriaController.salvarLote(array).finally(() => this._loaderService.hide());
    }

    getEnderecos(cdEndereco?: number): Promise<VistoriaDTO[]> {
        this._loaderService.show();
        return this._vistoriaController.getEnderecos(cdEndereco).finally(() => this._loaderService.hide());
    }

    getVistoria(cdVistoria: number): Promise<VistoriaDTO> {
        this._loaderService.show();
        return this._vistoriaController.getvistorias(cdVistoria).finally(() => this._loaderService.hide());
    }

    async find(vistoriaSearch?: VistoriaSearch): Promise<VistoriaListDTO> {
        this._loaderService.show()
        return await this._vistoriaController.find(vistoriaSearch && vistoriaSearch.getFilters() || null).finally( () => this._loaderService.hide());
    }

    async findVistoriador(vistoriaSearch?: VistoriaSearch): Promise<Array<Vistoria>> {
        this._loaderService.show()
        try {
            return await this._vistoriaController.findVistoriador(vistoriaSearch && vistoriaSearch.getFilters() || null).finally( () => this._loaderService.hide());
        }
        catch (error) { 
            this._loaderService.hide()
            return null; 
        }
    }

    async findConcessionario(vistoriaSearch?: VistoriaSearch): Promise<Array<Vistoria>> {
        this._loaderService.show()
        try {
            return await this._vistoriaController.findConcessionario(vistoriaSearch && vistoriaSearch.getFilters() || null).finally( () => this._loaderService.hide());
        }
        catch (error) { 
            this._loaderService.hide()
            return null; 
        }
    }

    async findVistoria(vistoriaSearch?: VistoriaSearch): Promise<Array<Vistoria>> {
        this._loaderService.show()
        try {
            return await this._vistoriaController.findVistoria(vistoriaSearch && vistoriaSearch.getFilters() || null).finally( () => this._loaderService.hide()); 
        }
        catch (error) { 
            this._loaderService.hide()
            return null; 
        }
    }

    async get(cdVistoria: number): Promise<Vistoria> {
        this._loaderService.show();
        return this._vistoriaController.get(cdVistoria).finally(() => this._loaderService.hide());
    }

    async save(vistoria: Vistoria): Promise<Vistoria> {
        this._loaderService.show();
        if (vistoria.cdVistoria && vistoria.cdVistoria > 0) {
            return this._vistoriaController.update(vistoria).finally(() => this._loaderService.hide());
        } else {
            return this._vistoriaController.create(vistoria).finally(() => this._loaderService.hide());
        }
    }

    async saveLote(array): Promise<Array<Vistoria>> {
        this._loaderService.show();

        return this._vistoriaController.createLote(array).finally(() => this._loaderService.hide());

    }

    async delete(cdVistoria: number) {
        this._loaderService.show();
        return this._vistoriaController.delete(cdVistoria).finally(() => this._loaderService.hide());
    }
    
}